// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3pTy0","icon":"SortAdornment_icon__3tpDz","up":"SortAdornment_up__3-Khu","down":"SortAdornment_down__2vpHx","active":"SortAdornment_active__1hZ2s"};